var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* styles */
require("!!./../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader!vue-loader/lib/style-rewriter?id=data-v-60a1381d!postcss-loader!sass-loader?indentedSyntax!vue-loader/lib/selector?type=styles&index=0!./GalleryBlock.vue")

/* script */
__vue_exports__ = require("!!coffee-loader!vue-loader/lib/selector?type=script&index=0!./GalleryBlock.vue")

/* template */
var __vue_template__ = require("!!vue-loader/lib/template-compiler?id=data-v-60a1381d!vue-loader/lib/selector?type=template&index=0!./GalleryBlock.vue")
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__



//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/GalleryBlock.vue
// module id = 32
// module chunks = 0